import { type CsvButlerItem, isCsvItemBlocked } from '../../../hooks/use-stm-quick-order-store'

interface CsvCheckAllState {
  checked: boolean
  indeterminate: boolean
  /** 點全選後要套用到可勾選商品的值 */
  nextChecked: boolean
}

// 缺貨等未通過檢查的商品勾不起來：它存在時全選只會停在半選，切換要看可勾選的商品，不能看 checkbox 自己的值
export const getCsvCheckAllState = (activeItems: CsvButlerItem[]): CsvCheckAllState => {
  const selectableItems = activeItems.filter(item => !isCsvItemBlocked(item))
  const checkedCount = selectableItems.filter(item => item.checked).length
  const checked = activeItems.length > 0 && checkedCount === activeItems.length
  return {
    checked,
    indeterminate: checkedCount > 0 && !checked,
    nextChecked: checkedCount < selectableItems.length,
  }
}
